
import { LuBuilding, LuCalendar, LuMessagesSquare, LuFileCheck, LuFileText, LuFingerprint, LuInfo, LuLayoutDashboard, LuListChecks, LuLock, LuPackage, LuPaperclip, LuSettings, LuSettings2, LuStickyNote, LuUser, LuUser2, LuView } from 'react-icons/lu';
import { APP_URLS } from '../../config';
import { COMMON_MENU } from './common/common';
import { FaFileInvoice, FaFileInvoiceDollar } from 'react-icons/fa';
import { GrDocumentDownload } from 'react-icons/gr';

export const ADMIN_MENU = [
    ...COMMON_MENU,
    {
        title: 'Users',
        icon: LuFingerprint,
        hasSubMenu: true,
        submenu: [
            {
                title: 'Employees',
                icon: LuUser2,
                path: APP_URLS.EMPLOYEES.ROUTE,
            },
            {
                title: 'Users List',
                path: APP_URLS.USERS.ROUTE,
                icon: LuFingerprint,
            },
            {
                title: 'Attendance',
                path: APP_URLS.ATTENDANCE.LIST,
                icon: LuListChecks
            },
            {
                title: 'Leaves',
                path: APP_URLS.LEAVES.ALL,
                icon: LuPaperclip
            },
            {
                title: 'Payslips',
                path: APP_URLS.PAYSLIP.ROUTE,
                icon: FaFileInvoiceDollar
            },
            {
                title: 'Conversations',
                path: APP_URLS.CONVERSATION.ALL,
                icon: LuMessagesSquare
            },
            {
                title: 'Reports',
                icon: GrDocumentDownload,
                path: APP_URLS.REPORT,
                hasSubMenu: false
            },
        ]
    },
    {
        title: "Manage Prospects",
        icon: LuFileText,
        hasSubMenu: true,
        submenu: [

            {
                title: 'My Prospects',
                path: APP_URLS.PROSPECTS.ROUTES,
                icon: LuStickyNote
            },
            {
                title: 'All Prospects',
                path: APP_URLS.PROSPECTS.ALL,
                icon: LuFileCheck,
            }
        ]

    },
    {
        title: 'Manage Sales',
        icon: LuStickyNote,
        hasSubMenu: true,
        submenu: [
            {
                title: 'View Accounts',
                path: APP_URLS.APPLICATION.ROUTE,
                icon: LuView
            },
            // {
            //     title: 'View Reports',
            //     path: APP_URLS.LEADS.REPORTS,
            //     icon: LuPackage
            // }
        ]
    },
    {
        title: 'Organization',
        icon: LuBuilding,
        hasSubMenu: true,
        submenu: [
            {
                title: "Products",
                path: APP_URLS.ORGANIZATION.ROUTE,
                icon: LuInfo
            },
            {
                title: 'Security',
                path: APP_URLS.ORGANIZATION.SECURITY,
                icon: LuLock
            },
            {
                title: 'Settings',
                path: APP_URLS.ORGANIZATION.SETTINGS,
                icon: LuSettings2
            }
        ]
    },

]